<button mat-icon-button class="close-button" (click)="cancelar()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>

<h1 mat-dialog-title>
  <mat-icon color="primary" class="icono-titulo">palette</mat-icon>
  {{ titulo }}
</h1>
<mat-divider></mat-divider>

<div mat-dialog-content class="contenido">

  <div class="row">
    <div class="col-lg-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Buscar icono</mat-label>
        <input matInput [(ngModel)]="busqueda" (ngModelChange)="filtrar()"
          placeholder="Ej: pago, casa, alarma">
        <button mat-icon-button matSuffix *ngIf="busqueda" (click)="limpiarBusqueda()"
          matTooltip="Limpiar">
          <mat-icon>close</mat-icon>
        </button>
        <mat-icon matSuffix *ngIf="!busqueda">search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <div class="vista-previa" *ngIf="seleccionado">
    <mat-icon color="primary">{{ seleccionado }}</mat-icon>
    <div class="detalle-previa">
      <span class="etiqueta">Seleccionado</span>
      <span class="nombre">{{ seleccionado }}</span>
    </div>
  </div>

  <app-sin-datos *ngIf="!hayResultados"
    icono="search_off"
    mensaje="Ningún icono coincide"
    detalle="Probá con otra palabra, o revisá la lista completa borrando el buscador."
    [compacto]="true">
  </app-sin-datos>

  <div class="grupo" *ngFor="let grupo of grupos">
    <span class="titulo-grupo">{{ grupo.grupo }}</span>

    <div class="grilla-iconos">
      <button type="button" class="celda-icono" *ngFor="let icono of grupo.iconos"
        [class.activo]="icono === seleccionado"
        (click)="elegir(icono)" (dblclick)="elegirYConfirmar(icono)"
        [matTooltip]="icono">
        <mat-icon>{{ icono }}</mat-icon>
        <span class="nombre-icono">{{ icono }}</span>
      </button>
    </div>
  </div>

</div>

<mat-divider></mat-divider>

<div mat-dialog-actions class="acciones">
  <button mat-button color="warn" (click)="quitar()">
    <mat-icon>do_not_disturb</mat-icon>
    Sin icono
  </button>

  <span class="spacer"></span>

  <button mat-button (click)="cancelar()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="confirmar()" [disabled]="!seleccionado">
    Aceptar
  </button>
</div>
